import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';
import ConfigCard from '../components/ConfigCard';
import ConfigTable from '../components/ConfigTable';
import TabBody from '../components/TabBody';
import { usePeopleConfig } from '../PeopleConfigContext';
import { formatDateTime } from '../configUtils';

/** Every configuration save, newest first. Not scoped by org/department. */
const ChangeHistoryTab: React.FC = () => {
  const { history, status, retry } = usePeopleConfig();
  const sorted = [...history].sort((a, b) => (a.at < b.at ? 1 : a.at > b.at ? -1 : 0));

  return (
    <TabBody>
      <ConfigCard
        title="Change History"
        subtitle="Each save records who changed it, when, the setting, the prior value, and the new value."
        status={status}
        onRetry={retry}
        table
      >
        <ConfigTable
          minWidth={1100}
          emptyMessage="No configuration changes yet."
          columns={[
            { key: 'at', header: 'Changed', flex: 1.2 },
            { key: 'by', header: 'Changed by' },
            { key: 'section', header: 'Section' },
            { key: 'setting', header: 'Setting', flex: 1.2 },
            { key: 'scope', header: 'Scope', flex: 1.2 },
            { key: 'prior', header: 'Prior value', flex: 1.2 },
            { key: 'next', header: 'New value', flex: 1.5 },
            // Mockup: text column, left aligned.
            { key: 'eff', header: 'Effective', flex: 1.2, align: 'left' },
          ]}
          rows={sorted.map((h, i) => ({
            key: `${h.at}-${i}`,
            cells: [
              formatDateTime(h.at),
              h.by,
              h.section,
              h.setting,
              h.scope,
              h.prior,
              <Text key="n" style={styles.strong}>{h.next}</Text>,
              h.effective,
            ],
          }))}
        />
      </ConfigCard>
    </TabBody>
  );
};

const styles = StyleSheet.create({
  strong: { fontSize: 14, fontFamily: FontFamily.bold, color: AdminColors.textPrimary },
});

export default ChangeHistoryTab;
